package ui.app.assign.detail


import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import api.AppType
import compose.assets.Svg
import compose.assets.svg.Alert
import org.jetbrains.compose.resources.StringResource
import ssoft.frontend.generated.resources.*
import tools.rememberString
import ui.widget.*


@Composable
fun AppDetailScope.AppDeleteDialog(state: DialogState, type: AppType) {
    AppDeleteDialog(
        state = state,
        type = type
    ) { deleteLogo: Boolean, deleteContent: Boolean ->
        action(AppDetailVM.Action.Delete(deleteLogo, deleteContent))
    }
}


@Composable
fun AppDeleteDialog(
    state: DialogState,
    type: AppType,
    makeDeletion: (deleteLogo: Boolean, deleteContent: Boolean) -> Unit
) {
    val deleteLogo = remember {
        mutableStateOf(true)
    }
    val deleteContent = remember {
        mutableStateOf(true)
    }
    Dialog(state) {
        DialogUI(
            Modifier.align(Alignment.Center),
            onDismissRequest = {
                state.hide()
            },
            title = {
                Row {
                    Icon(
                        imageVector = Svg.Alert,
                        contentDescription = null,
                        modifier = Modifier.align(Alignment.CenterVertically)
                    )
                    Space(24.dp)
                    Text(
                        text = Res.string.layer_bottom_detail__delete_title.rememberString(),
                        modifier = Modifier.align(Alignment.CenterVertically)
                    )
                }
            },
            confirmButton = {
                TextButton({
                    makeDeletion(
                        deleteLogo.value,
                        deleteContent.value
                    )

                    state.hide()
                }) { Text(Res.string.dialog__action_delete.rememberString()) }
            },
            dismissButton = {
                TextButton({
                    state.hide()
                }) { Text(Res.string.dialog__action_cancel.rememberString()) }
            },
        ) {
            Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                Text(Res.string.layer_bottom_detail__delete_message.rememberString())
                DeleteDialogCondition(
                    label = Res.string.layer_bottom_detail__delete_message_with_logo,
                    state = deleteLogo
                )
                when (type) {
                    AppType.RSS,
                    AppType.NONE,
                    AppType.WWW_LINK,
                    AppType.USB_PLAYER,
                    AppType.APP_GROUP -> Unit

                    AppType.IMAGE,
                    AppType.PDF,
                    AppType.VIDEO,
                    AppType.VIDEO_ALPHA_LOOP,
                    AppType.BALOON,
                    AppType.QUIZ,
                    AppType.GALLERY,
                    AppType.WHEEL,
                    AppType.KINDERGARTEN,
                    AppType.CAMERA,
                    AppType.MAZE,
                    AppType.WWW_EMBEDDED -> {
                        DeleteDialogCondition(
                            label = Res.string.layer_bottom_detail__delete_message_with_resources,
                            state = deleteContent
                        )
                    }


                }
            }
        }
    }
}


@Composable
private fun DeleteDialogCondition(
    label: StringResource,
    state: MutableState<Boolean>
) {
    Row(
        Modifier
            .fillMaxWidth()
            .clip(CardDefaults.shape)
            .clickable { state.value = !state.value }
            .padding(4.dp)
            .padding(horizontal = 4.dp)) {
        IconicSwitch(
            checked = state.value,
            modifier = Modifier.align(Alignment.CenterVertically),
            onCheckedChange = { state.value = it })
        Space(16.dp)
        Text(
            text = label.rememberString(),
            style = MaterialTheme.typography.bodyLarge,
            modifier = Modifier.align(Alignment.CenterVertically)
                .weight(1F)
        )
    }
}
